export default (clearStoreKeys = () => {}, additionalKeysToClear = [], clearLead = true) => {
    const storeKeys = [
        'tenant', 'unit', 'preRequisite',
        'vacantUnitsCountByUnitType', ...(Array.isArray(additionalKeysToClear) && additionalKeysToClear),
    ];
    if (clearLead) storeKeys.push('lead');
    clearStoreKeys(storeKeys);
};
